<template>
  <div class="page-wrapper">
    <AppHeader title="Gift Cards" />
    <div class="container-fluid">
    <Void
      :open="isVoidOpen"
      @getVoidPermission="setVoidPermission($event)"
      @close="isVoidOpen = !isVoidOpen"
    />
    <div style="display: none">
      <svg ref="barcode"></svg>
    </div>
    <div class="container-fluid">
      <div class="row topnav" style="padding-left: 15px">
        <!-- <div class="col-sm-1">
          <div
            class="dropdown"
            style="
              position: fixed;
              left: 0;
              top: 0;
              padding: 0;
              margin-top: 0;
              margin-bottom: 0;
            "
          >
            <MainMenu />
          </div>
        </div> -->
        <div class="col-sm-12">
          <div v-show="showError" style="text-align: center">
            <label class="h3" style="color: maroon">
              {{ this.mainErrorMsg }}
            </label>
          </div>
        </div>
      </div>
      <div v-if="showAddPromotion" class="container mt-4 mb-4" style="width: 80%; background-color: var(--form-color) ; padding: 30px; border-radius: 15px; box-shadow: 0 4px 15px rgba(0,0,0,0.3); color:#fff;box-shadow: 0 10px 30px rgba(0,0,0,0.3);">
        <h3 class="text-white mb-4 border-bottom pb-2">{{ giftCardId === -1 ? 'Create New GiftCard' : 'Edit GiftCard Details' }}</h3>
        
        <div class="row text-white" style="color: #fff;">
          <!-- Customer -->
          <div class="col-md-6 mb-3">
             <label class="form-label h2 text-white">Customer</label>
             <select class="form-control form-control-lg" v-model="customer" style="font-size:1.3em; height: auto;">
                <option style="color: black;" v-for="customer of customers" :key="customer.id" :value="customer.id">{{ customer.name }}</option>
             </select>
          </div>

          <!-- GiftCard Name -->
          <div class="col-md-6 mb-3">
             <label class="form-label h2 text-white">GiftCard Name</label>
             <input type="text" v-model="giftcardname" class="form-control form-control-lg" style="font-size: 1.3em" placeholder="Enter name" />
          </div>

          <!-- Balance -->
          <div class="col-md-6 mb-3">
             <label class="form-label h2 text-white">Balance</label>
             <input type="number" v-model="balance" class="form-control form-control-lg" style="font-size: 1.3em" placeholder="0.00" />
          </div>

          <!-- Number Of Cards -->
          <div class="col-md-6 mb-3">
             <label class="form-label h2 text-white">Number Of Cards</label>
             <input type="number" v-model="number_of_cards" class="form-control form-control-lg" style="font-size: 1.3em" placeholder="1" />
          </div>

          <!-- Valid Till -->
          <div class="col-md-6 mb-3">
             <label class="form-label h2 d-block text-white">Valid Till</label>
             
             <div class="rounded">
                <datepicker
                    v-model="valid_to"
                    name="valid_to"
                    format="yyyy-MM-dd"
                    :pickTime="true"
                    @selected="parentfunctionSelectedhandler"
                    @opened="datepickerOpenedFunction"
                    @closed="parentfunctionCloseHandler"
                    style="border: none;"
                ></datepicker>
             </div>
          </div>

          <!-- Buttons -->
          <div class="col-md-12 text-right mt-4 pt-3 border-top">
            <button
              class="btn btn-success btn-lg"
              v-if="giftCardId === -1"
              style="font-size: 1.5em; margin-right: 20px; min-width: 150px;"
              @click="createGiftCard"
            >
              Save
            </button>
            <button
              class="btn btn-success btn-lg"
              v-if="giftCardId !== -1"
              style="font-size: 1.5em; margin-right: 20px; min-width: 150px;"
              @click="updateGiftCard"
            >
              Update
            </button>
            <button
              class="btn btn-danger btn-lg"
              style="font-size: 1.5em; min-width: 150px;"
              @click="cancelSavePromotion"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
      <div v-if="toggle">
    

      <div class="touch-search-header">
        <div class="touch-search-area">
          <div class="input-group touch-search-group">
            <span class="input-group-addon">
              <i class="glyphicon glyphicon-search"></i>
            </span>
            <input
              type="text"
              v-model="searchGiftCard"
              class="form-control input-lg"
              placeholder="Search by name or number"
              @keyup.enter="applyGiftCardSearch()"
            />
            <span class="input-group-btn">
              <button class="btn btn-success btn-lg" @click="applyGiftCardSearch()">
                Search
              </button>
            </span>
          </div>
        </div>

        <div class="touch-search-actions">
          <button
            class="btn btn-success btn-lg"
            v-if="hasPermission(49)"
            @click="handleAddGiftCard"
          >
            New GiftCard
          </button>
        </div>
      </div>
    
       <br>
        <div
          v-if="toggle"
          class="table-wrap"
          style="color: #fff; "
        >
          <table class="table" style="color: #fff">
            <thead>
              <tr>
                <th style="font-size: 1em">Customer</th>
                <th style="font-size: 1em">GiftCard Name</th>
                <th style="font-size: 1em">GiftCard Number</th>
                <th style="font-size: 1em">Balance</th>
                <!-- <th style="font-size: 1em">Number Of Cards</th> -->
                <th style="font-size: 1em">Valid To</th>
                <th style="font-size: 1em"></th>
                <th style="font-size: 1em"></th>
                <th style="font-size: 1em"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="giftCard in filteredGiftCards" :key="giftCard.id">
                <td style="font-size: 1em; width: 8%">
                  {{ giftCard.customer_name }}
                </td>
                <td style="font-size: 1em; width: 25%">
                  {{ giftCard.giftcardname }}
                </td>
                <td style="font-size: 1em">{{ giftCard.giftcardnumber }}</td>
                <td style="font-size: 1em">{{ giftCard.balance }}</td>
                <!-- <td style="font-size: 1em">{{ giftCard.number_of_cards }}</td> -->
                <td style="font-size: 1em">{{ giftCard.valid_to }}</td>
                <!-- <td>
                  <button
                    class="btn btn-warning"
                    style="font-size: 1em"
                    @click="printGiftCard(giftCard)"
                  >
                    Print
                  </button>
                </td> -->
                <td>
                  <button
                    v-if="hasPermission(50)"
                    class="btn btn-success"
                    style="font-size: 1em"
                    @click="editGiftCard(giftCard)"
                  >
                    Edit
                  </button>
                </td>
                <td>
                  <button
                    v-if="hasPermission(51)"
                    class="btn btn-danger"
                    style="font-size: 1em"
                    @click="deleteGiftCard(giftCard)"
                  >
                    Delete
                  </button>
                </td>
                <td>
                  <button
                    class="btn btn-primary"
                    style="font-size: 1em"
                    @click="showInvoices(giftCard)"
                  >
                    Show Invoices
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div
        v-if="showInvoicesFlag"
        class="container-fluid"
        style="color: #fff; "
      >
        <!-- <div style="margin-bottom: 10px;">
          <button
            class="btn btn-success"
            style="font-size: 1em"
            @click="printGiftCardOrders()"
          >
            Print
          </button>

          <button
            class="mx-4 btn btn-danger"
            style="font-size: 1em; margin: 0 1.5rem"
            @click="cancelSavePromotion()"
          >
            Back
          </button>
        </div> -->
          <div style="display:flex; justify-content:flex-end; width:100%; margin-bottom:10px;">
              <button class="btn btn-success" style="font-size:1em" @click="printGiftCardOrders()">Print</button>
                          <span style="display:inline-block;width:1.5rem;"></span>
              <button class="btn btn-danger" style="font-size:1em" @click="cancelSavePromotion()">Cancel</button>
        </div>
        <table class="table" style="color: #fff">
          <thead>
            <tr>
              <th style="font-size: 1em; text-align: left">Date</th>
              <th style="font-size: 1em; text-align: left">Invoice No</th>
              <th style="font-size: 1em; text-align: left">Cashier</th>
              <th style="font-size: 1em; text-align: left">Customer</th>
              <th style="font-size: 1em; text-align: right">Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="invoice in giftCardOrders" :key="invoice.invoice">
              <td style="font-size: 1em; text-align: left">
                {{ invoice.createdOn }}
              </td>
              <td style="cursor: pointer;font-size:1em;text-align: left;" @click="goToFindInvoice(invoice.invoice)">
                {{ invoice.invoice }}
              </td>
              <td style="font-size: 1em; text-align: left">
                {{ invoice.partOne }}
              </td>
              <td style="font-size: 1em; text-align: left">
                {{ invoice.customer_name }}
              </td>
              <td style="font-size: 1em; text-align: right">
                {{
                  invoice.totalPrice != 0
                    ? formatNumber(invoice.totalPrice)
                    : "-"
                }}
              </td>
            </tr>
            <tr>
              <td style="font-size: 1em; text-align: left">Total Amounts</td>
              <td style="font-size: 1em; text-align: left"></td>
              <td style="font-size: 1em; text-align: left"></td>
              <td style="font-size: 1em; text-align: left"></td>
              <td style="font-size: 1em; text-align: right">
                {{ formatNumber(totalOrderPrice) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import JsBarcode from "jsbarcode";
import axios from "axios";
import commonServices from "@/shared/commonServices";
import AppHeader from "@/components/AppHeader";
import Datepicker from "vuejs3-datepicker";
import Void from "@/components/Void";
export default {
  mixins: [commonServices],
  mounted() {
    const self = this;
    this.handleSyncGiftCards().then(async () => {
      await self.findCustomerByCond();
      await self.getAllGiftCards();
    });
    if (localStorage.userId !== undefined && localStorage.appId !== undefined) {
    } else {
      this.$router.push({ giftcardname: "login" });
    }
    this.language = "ar";
    this.handleLanguage();
    this.logoImage =
      '<img src="' + this.logoUrl + '" width="70" height="50" alt="Logo">';
  },
  components: { AppHeader, Void, Datepicker },
  data: function () {
    return {
      showAddPromotion: false,
      allGiftCards: [],
      searchGiftCardName: "",
      searchGiftCardNumber: "",
      searchGiftCard: "",
      giftCardJson: {},
      customers: [],
      giftCardId: -1,
      giftcardname: "",
      customer: "",
      customersJson: {},
      valid_to: new Date(),
      number_of_cards: "",
      authorizedToChangePrice: "N",
      totalOrderPrice: 0,
      isVoidOpen: false,
      giftcardnumber: "",
      balance: "",
      showError: false,
      giftCardOrders: [],
      showInvoicesFlag: false,
      mainErrorMsg: "",
      logoUrl: "",
      jsonData: {},
      language: "en",
      languageName: "",
      toggle: true,
    };
  },
  computed: {
  filteredGiftCards() {
  let list = this.allGiftCards || [];
  const search = (this.searchGiftCard || "").toLowerCase();

  if (search) {
    list = list.filter((gc) =>
      (gc.giftcardname || "").toLowerCase().includes(search) ||
      (gc.giftcardnumber || "").toLowerCase().includes(search) ||
      (gc.customer_name || "").toLowerCase().includes(search) ||
      (gc.balance || "").toString().toLowerCase().includes(search) 
    );
  }

  return list;
},
  },
  methods: {
    findCustomerByCond: async function(){
      this.customersJson.appId = localStorage.appId;
      this.customersJson.customer = "";
      try{
          let dataURL = this.apiURL+'Customers/getCustomersByCondNew';
          let response = await axios.post(dataURL, this.customersJson);  
          if(response.data.status === 'success'){
            this.customers = response.data.results.customers;
          }
      }
      catch (error){
          console.log(error);
      }
    },   
    applyGiftCardSearch() {
      this.searchGiftCard = (this.searchGiftCard || "").trim();
    },
    printGiftCard(giftcard) {
      JsBarcode(this.$refs.barcode, giftcard.giftcardnumber, {
        format: "code128",
        background: "transparent",
        displayValue: false,
      });
      const svg = this.$refs.barcode;
      const xml = new XMLSerializer().serializeToString(svg);
      const svg64 = btoa(xml);
      const image64 = `data:image/svg+xml;base64,${svg64}`;
      let elem = "";
      const totalCards = parseInt(this.number_of_cards);
      const cardsPerPage = 3;
      const totalOuterLoops = Math.ceil(totalCards / cardsPerPage);

      for (let outerIndex = 0; outerIndex < totalOuterLoops; outerIndex++) {
        elem += `
    <div style="position: relative; width: 100%;">
      <div style="width: 100%; height: 100%;">
  `;


        for (
          let innerIndex = 0;
          innerIndex < cardsPerPage &&
          outerIndex * cardsPerPage + innerIndex < totalCards;
          innerIndex++
        ) {
          const cardIndex = outerIndex * cardsPerPage + innerIndex;
          const pTopPosition = 23.5 + innerIndex * 33.5; // For <p>
          const divInnerTopPosition = 7 + innerIndex * 33.5; // For the inner <div>

          elem += `
      <p style="position: absolute; left: 15%; top: ${pTopPosition}%; font-size: 1.5rem; color: #707070;">
        ${
          giftcard.customer_name
            ? "Mr/Ms " + giftcard.customer_name
            : "Dear Customer"
        }
      </p>
      <div style="position: absolute; top: ${divInnerTopPosition}%; right: 8%; color: #707070; width: 47%;">
        <div style="display: flex; justify-content: space-around; align-items: center;">
          <div style="font-size: 0.8rem; line-height: 0;">
            <div style="display: flex; justify-content: space-between; align-items: center;">
              <p>Issued on</p>
              <p>${this.getGiftCardDate(new Date().toDateString())}</p>
            </div>
            <div style="display: flex; justify-content: space-between; align-items: center;">
              <p>Valid Till</p>
              <p>${this.getGiftCardDate(giftcard.valid_to)}</p>
            </div>
            <div style="display: flex; justify-content: space-between; align-items: center;">
              <p>Issued By</p>
              <p>${localStorage.username}</p>
            </div>
          </div>
          <div>
            <h2 style="font-size: 1.5rem;">Ush ${this.formatNumber(
              giftcard.balance
            )}</h2>
          </div>
        </div>
        <div style="display:flex; justify-content: center;">
          <img src="${image64}" style="height: 100px;">
        </div>
        <div style="display:flex; justify-content: center; font-size: 0.65rem;">
          <p style="margin: 0;">Amount (in words) ${this.getNumberWords(
            giftcard.balance
          )} Uganda Shilling</p>
        </div>
      </div>
    `;
        }

        elem += `</div>`; // Close the outer <div> for this batch
      }

      // src="https://barcode.tec-it.com/barcode.ashx?data=${
      //   this.giftcardnumber
      // }&code=Code128&translate-esc=on&imagetype=Jpg"

      var mywindow = window.open(
        "",
        "PRINT",
        "toolbar=no,status=no,menubar=no,scrollbars=no,resizable=no,left=0, top=0, width=10, height=10, visible=none"
      );
      mywindow.document.write(elem);
      this.number_of_cards = "";
      setTimeout(function () {
        mywindow.print();
        // mywindow.close();
      }, 500);
    },
    editGiftCard(giftCard) {
      this.giftcardname = giftCard.giftcardname;
      this.giftcardnumber = giftCard.giftcardnumber;
      this.balance = giftCard.balance;
      this.customer = giftCard.customer;
      this.giftCardId = giftCard.id;
      this.toggle = false;
      this.showAddPromotion = true;
    },
    deleteGiftCard: function (giftCard) {
      this.isVoidOpen = true;
      this.giftCardId = giftCard.id;
    },
    handleSyncGiftCards: async function () {
      try {
        let dataURL = this.apiURL + "GiftCards/syncGiftCards";
        let response = await axios.post(dataURL, {});
        if (response.data.status === "success") {
        } else {
          this.showAlert(
            "Error Happened While Syncing GiftCards Please Check Your Network!"
          );
        }
      } catch (error) {
        console.log(error);
      }
    },
    createGiftCard: async function () {
      if (this.balance == "" || this.giftcardname == "") {
        this.showAlert("Please Fill All fields!");
        return;
      }
      this.giftcardnumber = Array.from({ length: 13 }, () =>
        Math.floor(Math.random() * 10)
      ).join("");
      this.giftCardJson.appId = localStorage.appId;
      this.giftCardJson.giftcardname = this.giftcardname;
      this.giftCardJson.giftcardnumber = this.giftcardnumber;
      this.giftCardJson.customer = this.customer;
      this.giftCardJson.customer_name = this.customers[this.customers.findIndex(el => el.id == this.customer)].name;
      this.giftCardJson.balance = this.balance;
      this.giftCardJson.valid_to = this.valid_to;
     this.giftCardJson.number_of_cards = this.number_of_cards;
      try {
        let dataURL = this.apiURL + "GiftCards/createGiftCard";
        let response = await axios.post(dataURL, this.giftCardJson);
        if (response.data.status === "success") {
          this.showSuccess("GiftCard Added Successfully!");
          this.printGiftCard(this.giftCardJson);
          this.getAllGiftCards();
          this.cancelSavePromotion();
        } else {
          this.showAlert("Error Happened Please Check Entered Data!");
        }
      } catch (error) {
        console.log(error);
      }
    },
    cancelSavePromotion() {
      this.toggle = true;
      this.showInvoicesFlag = false;
      this.showAddPromotion = false;
      this.showPermissions = false;
      this.showDuplicatePromotion = false;
    },
    async setVoidPermission(authorizedToChangePrice) {
      if (authorizedToChangePrice === "Y") {
        this.giftCardJson.appId = localStorage.appId;
        this.giftCardJson.id = this.giftCardId;

        try {
          let dataURL = this.apiURL + "GiftCards/deleteGiftCard";
          let response = await axios.post(dataURL, this.giftCardJson);
          if (response.data.status === "success") {
            this.showSuccess("GiftCard Deleted Successfully!");
            this.getAllGiftCards();
            this.cancelSavePromotion();
          } else {
            this.showAlert("Error Happened Please Check Entered Data!");
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        // Error message mo permission
      }
      this.authorizedToChangePrice = "N";
    },
    printGiftCardOrders() {
      const nowDate = new Date();
      let year = nowDate.getFullYear();
      let month = nowDate.getMonth() + 1;
      let day = nowDate.getDate();
      let reportDate = year + "-" + month + "-" + day;
      var today = new Date();
      var time =
        today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      let reportHeader =
        "Giftcard Number: " + this.giftCardJson.giftCardNumber + " Orders";
      let reportFooter =
        "Printed on: " + year + "-" + month + "-" + day + " " + time;
      this.printInvoices(
        reportDate,
        reportHeader,
        reportFooter,
        this.giftCardOrders,
        this.totalOrderPrice
      );
    },

    printInvoices(
      reportDate,
      reportHeader,
      reportFooter,
      giftCardOrders,
      invoices_total
    ) {
      let viaInvStr = '<table width="100%">';
      viaInvStr = viaInvStr + "<tr><td>";
      viaInvStr = viaInvStr + "<tr><td>";
      viaInvStr =
        viaInvStr +
        '<table align="center" width="100%"  style="border-bottom: #000000 2px solid; vertical-align:bottom"><tr><td  align="center" style="vertical-align:bottom"><b><p style="font-size:1em">' +
        reportHeader +
        "</p></b></td></tr></table>";
      viaInvStr = viaInvStr + "</td></tr>";
      viaInvStr = viaInvStr + "<tr><td>";
      viaInvStr =
        viaInvStr +
        '<table align="left" width="100%"  style="border-bottom: #000000 2px solid;"><tr><td align="left" ><b><p style="font-size:1em">Date:</p></b></td><td align="left"><b><p style="font-size:1em">' +
        reportDate +
        "</p></b></td></tr></table>";
      viaInvStr = viaInvStr + "</td></tr>";
      viaInvStr = viaInvStr + "<tr><td>";
      viaInvStr = viaInvStr + '<table align="left" width="100%">';
      viaInvStr =
        viaInvStr +
        '<tr><td align="left"><b><p style="font-size:1em">Date</p></b></td><td align="left"><b><p style="font-size:1em">Invoice No</p></b></td><td align="left"><b><p style="font-size:1em">Customer</p></b></td><td align="right"><b><p style="font-size:1em">Cashier</p></b></td><td align="center"><b><p style="font-size:1em">Amount</p></b></td></tr>';
      let _this = this;
      for (let i = 0; i < giftCardOrders.length; i++) {
        const item = giftCardOrders[i];
        viaInvStr = viaInvStr + "<tr>";
        viaInvStr =
          viaInvStr +
          '<td align="left"><p style="font-size:1em">' +
          item.createdOn +
          "</p></td>";
        viaInvStr =
          viaInvStr +
          '<td align="left"><p style="font-size:1em">' +
          item.invoice +
          "</p></td>";
        viaInvStr =
          viaInvStr +
          '<td align="left"><p style="font-size:1em">' +
          item.customer_name +
          "</p></td>";
        viaInvStr =
          viaInvStr +
          '<td align="left"><p style="font-size:1em">' +
          item.partOne +
          "</p></td>";
        viaInvStr =
          viaInvStr +
          '<td align="right"><p style="font-size:1em">' +
          (item.totalPrice != 0 ? this.formatNumber(item.totalPrice) : "-") +
          "</p></td>";
        viaInvStr = viaInvStr + "</tr>";
      }
      viaInvStr = viaInvStr + "<tr>";
      viaInvStr =
        viaInvStr +
        '<td style="border-top: #000000 2px solid; vertical-align:bottom" align="left"><p style="font-size:1em">Total Amounts</p></td>';
      viaInvStr =
        viaInvStr +
        '<td style="border-top: #000000 2px solid; vertical-align:bottom" align="left"><p style="font-size:1em"></p></td>';
      viaInvStr =
        viaInvStr +
        '<td style="border-top: #000000 2px solid; vertical-align:bottom" align="left"><p style="font-size:1em"></p></td>';
      viaInvStr =
        viaInvStr +
        '<td style="border-top: #000000 2px solid; vertical-align:bottom" align="left"><p style="font-size:1em"></p></td>';
      viaInvStr =
        viaInvStr +
        '<td style="border-top: #000000 2px solid; vertical-align:bottom" align="right"><p style="font-size:1em">' +
        (invoices_total != 0 ? _this.formatNumber(invoices_total) : "-") +
        "</p></td>";
      viaInvStr = viaInvStr + "</tr>";
      viaInvStr = viaInvStr + "</td></tr>";
      viaInvStr = viaInvStr + "</table>";

      viaInvStr = viaInvStr + "<tr><td>";
      viaInvStr =
        viaInvStr +
        '<table align="center" width="100%"  style="border-bottom: #000000 2px solid; vertical-align:bottom"><tr><td width="100%" align="center" style="vertical-align:bottom"><b><p style="font-size:1em">' +
        reportFooter +
        "</p></b></td></tr></table>";
      viaInvStr = viaInvStr + "</td></tr>";

      viaInvStr = viaInvStr + "</table>";
      this.sharedPrintElemmRep(viaInvStr);
    },

    updateGiftCard: async function () {
      if (this.giftcardnumber == "" || this.giftcardname == "") {
        this.showAlert("Please Fill All fields!");
        return;
      }
      this.giftCardJson.appId = localStorage.appId;
      this.giftCardJson.id = this.giftCardId;
      this.giftCardJson.giftcardname = this.giftcardname;
      this.giftCardJson.giftcardnumber = this.giftcardnumber;
      this.giftCardJson.balance = this.balance;
      this.giftCardJson.customer = this.customer;
      this.giftCardJson.customer_name = this.customers[this.customers.findIndex(el => el.id == this.customer)].name;
      this.giftCardJson.valid_to = this.valid_to;
      this.giftCardJson.number_of_cards = this.number_of_cards;

      try {
        let dataURL = this.apiURL + "GiftCards/updateGiftCard";
        let response = await axios.post(dataURL, this.giftCardJson);
        if (response.data.status === "success") {
          this.showSuccess("GiftCard Updated Successfully!");
          this.printGiftCard(this.giftCardJson);
          this.getAllGiftCards();
          this.cancelSavePromotion();
        } else {
          this.showAlert("Error Happened Please Check Entered Data!");
        }
      } catch (error) {
        console.log(error);
      }
    },

    handleAddGiftCard: async function () {
      this.showAddPromotion = true;
      this.giftCardId = -1;
      this.giftcardname = "";
      this.giftcardnumber = ""
      this.customer = "";
      this.giftCardJson.valid_to = new Date();
      this.giftCardJson.number_of_cards = "";
      this.ura = "";
      this.balance = "";
      this.showError = false;
      this.mainErrorMsg = "";
      this.showAddCustomer = true;
      this.toggle = false;
    },
    getAllGiftCards: async function () {
      this.giftCardJson.appId = localStorage.appId;
      const self = this;
      try {
        let dataURL = this.apiURL + "GiftCards/getAllGiftCards";
        let response = await axios.post(dataURL, this.giftCardJson);
        if (response.data.status === "success") {
          this.allGiftCards = response.data.results;
          this.allGiftCards.forEach(el => {
            const custIndex = self.customers.findIndex(e => e.id == el.customer)  
            if(custIndex > -1){
              el.customer_name = self.customers[custIndex].name
            }
          })
        }
      } catch (error) {
        console.log(error);
      }
      return this.allGiftCards;
    },
    showInvoices: async function (giftCard) {
      this.giftCardJson.appId = localStorage.appId;
      this.giftCardJson.giftCardNumber = giftCard.giftcardnumber;
      try {
        let dataURL = this.apiURL + "GiftCards/getGiftCardOrders";
        let response = await axios.post(dataURL, this.giftCardJson);
        if (response.data.status === "success") {
          this.giftCardOrders = response.data.results;
          if (this.giftCardOrders.length > 0) {
            this.totalOrderPrice = 0;
            this.giftCardOrders.forEach((el) => {
              this.totalOrderPrice += parseFloat(el.totalPrice);
            });
            this.showInvoicesFlag = true;
            this.toggle = false;
          } else {
            this.showAlert("There are no invoices for this giftCard");
          }
        }
      } catch (error) {
        console.log(error);
      }
      return this.giftCardOrders;
    },
    goToFindInvoice: function (invoiceNumber) {
      this.$router.push({ name: 'find', params: { invoiceNumber } });
    },
  },
};
</script>
<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  margin-top: 0px;
}

.glyphicon.glyphicon-ok {
  font-size: 30px;
}

.button {
  font: bold 15px Arial;
  text-decoration: none;
  background-color: #eeeeee;
  color: #333333;
  /* padding: 2px 6px 2px 6px;
  border-top: 1px solid #cccccc;
  border-right: 1px solid #333333;
  border-bottom: 1px solid #333333;
  border-left: 1px solid #cccccc; */
}

.grid-container-element {
  display: grid;
  grid-template-columns: 5fr 1.5fr 1.5fr 1.5fr 0.5fr;
  grid-gap: 10px;
  border: 1px solid whitesmoke;
  border-left: 0px;
  border-right: 0px;
  border-top: 0px;
  width: 100%;
}

.grid-child-element_ {
  margin: 10px;
  border: 1px solid red;
}

.grid-child-element {
  margin: 2px;
  border-left: 0px;
  border-right: 0px;
  border-top: 0px;
  padding: 0 px;
}

.check-label {
  color: #fff;
  font-size: 1.5rem;
  margin-left: 1rem;
  margin: 1rem 0;
}

.vuejs3-datepicker__calendar.vuejs3-green,
#calendar-div {
  color: #000 !important;
}
.mb-3{
  margin-bottom: 1rem;
}


/* Hide scrollbar for Chrome, Safari and Opera */
.no-scrollbar::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.no-scrollbar {
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}
.form-label{
  font-size: 1.5rem !important;
}
</style>
